import * as React from "react";
import { SimpleTextPhase } from "../../../components/SimpleTextPhase";
import { clickedIssuerWebsiteLink } from "../../../lib/Avo";
import useAppSelector from "../../../hooks/useAppSelector";
export default function BaseIssuerWebsite(_a) {
    var issuer = _a.issuer;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    return (React.createElement(SimpleTextPhase, { title: "Create an account" },
        React.createElement("p", null, "To register for a new account please visit your provider's website:"),
        React.createElement("p", { className: "text-center" }, issuer ? (React.createElement("a", { href: issuer.site, target: "_blank", rel: "noopener noreferrer", className: "text-current no-underline", onClick: function () {
                clickedIssuerWebsiteLink(commonAnalyticsProperties);
                return true;
            } }, issuer.site)) : null)));
}
